import { render, staticRenderFns } from "./MEditItem.vue?vue&type=template&id=10bbb0e4&scoped=true"
import script from "./MEditItem.vue?vue&type=script&lang=js"
export * from "./MEditItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bbb0e4",
  null
  
)

export default component.exports